import { Component, OnInit, Output, Input, EventEmitter, Inject, } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import jwt_decode from "jwt-decode";
import { AuthenticationService } from '../../core/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersRoleService } from '../user-role/users-role.service';
import { LoginapiService } from '../../auth/loginapi.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';
import { NgbModule, } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
type AOA = any[][];
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

export class TopbarComponent implements OnInit {
  subscription$: Subscription = new Subscription();
  selectedType: any;
  passwordChangeForm: FormGroup;
  bulkEnrollmentForm: FormGroup
  loginUserDetail: any
  loginUser: any;
  user: any;
  multiRoles: any;
  userRoleResponse: any;
  data: any = []
  loginResponse: any;
  dataLoginName: any;
  selectUserData:any =[]
  vinstatus: boolean;
  eligiblity: any;
  message: string;
  vinId: any;
  fileName: any;
  files: any;
  vinData: any;
  searchId: any 
  description: string = ''
  searchName: any = ''
  dataUpload: boolean = true;
  bulkData: any;
  validationVIN: boolean = true
  vinDataMain: any;
  consumerData:any = {opentype:[{name:'A***a',value:'azuga'},{name:'I*T',value:'imt'},{name:'R*******M',value:'rockingham '}],provider:[{name:'S******s',value:'stellantis'}], admin:[{name:'Admin',value:'admin'}]}
  userDash: any;
  changeRole: boolean;
  IsDisabled: boolean = true
  customConsumer: any;
  enrollMentCheckForm: FormGroup
  loading: boolean = false;
  constructor(@Inject(DOCUMENT) private document: any, private fb: FormBuilder,private spinner: NgxSpinnerService, private toastr: ToastrService, private loginapiservice: LoginapiService, private modalService: NgbModal, private _userRole: UsersRoleService, private router: Router, private authService: AuthenticationService) { 
    this.bulkEnrollmentsForm();
    this.createvinEligibility();
  }
  openMobileMenu: boolean;
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    
    this.spinner.show()
    this.openMobileMenu = false;
    this.loginUserDetail = sessionStorage.getItem('user-token');
    this.showRole();
    this.decodeToken()
    this.createEnrollForm();    
    // if(this.router.url == 'adlp/dashboard/salesDashboard') {
      // this.getBulkdata()
    // }
    this.bulkEnrollmentsForm();
    this.spinner.hide()
  }

  showRole() {
    let userRolLogin = JSON.stringify(sessionStorage.getItem('userRole'));
    this.user = JSON.parse(userRolLogin);
    this.multiRoles = JSON.parse(sessionStorage.getItem('multiRole'));
     
    let customConsumers =JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer=JSON.parse(customConsumers); 
  }

  
  resetBulk() {
    this.bulkEnrollmentForm.reset();
    this.fileName = ''
    this.description = ''
    this.dataUpload = false;
    this.enrollMentCheckForm.reset();
    this.vinstatus = false
  }

  openModal(content: any) {
    this.modalService.open(content);
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }
  get_check_digit(vin) {
    var map = '0123456789X';
    var weights = '8765432X098765432';
    var sum = 0;
    for (var i = 0; i < 17; ++i)
      sum += this.transliterate(vin[i]) * map.indexOf(weights[i]);
    return map[sum % 11];
  }

  largeModal3(support: any) {
    this.modalService.open(support, { size: 'sl', centered: true });
  }

  transliterate(c) {
    return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
  }

  uploadFiles(evt: any) {
    const files1 = evt.target.files;
    var fileTypes = ['csv'];
    if (files1.length > 0) {
      this.fileName = evt.target.files[0].name;
      var fileExtension = evt.target.files[0].name.split('.').pop().toLowerCase(),
        isSuccess = fileTypes.indexOf(fileExtension) > -1;
      if (isSuccess) {
        this.files = evt.target.files.item(0)

        const target: DataTransfer = <DataTransfer>(evt.target);
        this.IsDisabled = false
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          this.data = <AOA>(XLSX.utils.sheet_to_json(ws));

        };
        reader.readAsBinaryString(target.files[0]);
      } else {
        this.files = null;
        this.fileName = null;
      }
    } else {
      this.fileName = null
    }
  }


  checkVin1(evt) {
    let vin = evt.toUpperCase()
    if (this.validateVin(vin)) {
      this.validationVIN = true
    } else {
      this.validationVIN = false
    }
  }

  
  validateVin(vin) {
    return this.validate(vin);
  }

  validate(vin) {
    if (vin.length !== 17) return false;
    return this.get_check_digit(vin) === vin[8];
  }
  supportData(){
    this.router.navigate(['adlp/admin/dashoard/jiraSupport'])
  }
  
  logout() {
    let userdata = JSON.parse(this.loginUserDetail);
    let token = userdata.accessToken;
    const logoutToken: any = {
      accessToken: token
    }
    this.authService.logOut(logoutToken);
  }
  decodeToken() {
    var userdetail = JSON.parse(this.loginUserDetail)
    if (userdetail)
      var token = userdetail.idToken;
    this.loginUser = jwt_decode(token);
  }

  datapihub() {
    this.router.navigate(['adlp/developer-corner/dataapihub']);
  }

  cxtaxonomy() {
    this.router.navigate(['adlp/developer-corner/cerebrumx-taxonomy'])
  }

  createcustommodel() {
    this.router.navigate(['adlp/developer-corner/custom-model'])
  }

  vindecoder(){
    this.router.navigate(['adlp/developer-corner/generatereports'])
  }
  quickSight() {
    this.router.navigate(['adlp/dashboard/quicksight'])
  }

  tco(){
    this.router.navigate(['adlp/developer-corner/tco'])
  }

  datareset(){
    this.vinstatus = false
  }

  validateMaskIng(el, e) {
    var regex = /^[a-zA-Z0-9]*$/;
    var key = e.clipboardData.getData('text')    
    if (!regex.test(key)) {
      e.preventDefault();
      return false;
    }
  }

  numbersOnlyUpto(event: any) {
    const pattern = /[0-9, A-Z, a-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  logologout(){
    this.router.navigate(['/auth/login']);
  }

  pendingData(){
    this.router.navigate(['adlp/developer-corner/nodatareceived'])
  }
  onChange(event) {
    this.selectedType = event.target.value;
    if(this.selectedType == 'provider') {
      this.changeRole = true;
      this.selectUserData = this.consumerData.provider
    } else if(this.selectedType == 'admin') {
      this.changeRole = true;
      this.selectUserData = this.consumerData.admin
      
    } else {
      this.changeRole = true;
      this.selectUserData = this.consumerData.opentype
    }
  }

  selectDashboard(evt) {
    this.userDash = evt;
  }

  createEnrollForm() {
    this.passwordChangeForm = this.fb.group({
      oldPassword: ['', [Validators.required, ]],
      newPassword: ['', Validators.required],
    })
  }

  addEnroll(form) {
    let enrollData = {
      'oldPassword': form.oldPassword,
      'newPassword': form.newPassword,
    }
    this.subscription$.add(
      this._userRole.getChangePassword(enrollData).subscribe((res: any) => {
        this.spinner.show()
        if (res) {
            this.toastr.success("Password Change Successfully");
            this.passwordChangeForm.reset();
            this.logout()
          this.spinner.hide()
        }
      }, (err) => {
        this.toastr.error("Something Went Wrong")
      }))
  }

  bulkEnrollmentsForm() {
    this.bulkEnrollmentForm = this.fb.group({
      description: ['', Validators.required],
      oem: ['', Validators.required],
    })
  }

 
  checkVin(form) {
    let enrollDatas = {
      'vin': form.vins,
      'providerId': Number(form.oems),
    }
    this.spinner.show()
    this.subscription$.add(
      this.authService.addverification((enrollDatas)).subscribe((res: any) => {
        this.vinId = res.vin.toUpperCase()
        this.eligiblity = res.eligible
        this.spinner.hide()
        this.vinstatus = true
        if (this.eligiblity) {
          this.eligiblity = 'True'
          this.message = "VIN Eligible for Enrollment"
        }
        else {
          this.eligiblity = 'False'
          this.message = "VIN not Eligible for Enrollment"
        }
      }, (err) => {
        this.toastr.error(err.error.apierror.message)
        this.spinner.hide()
      }))

  }

  uploadFile(evt: any) {
    const files1 = evt.target.files;
    var fileTypes = ['csv'];
    if (files1.length > 0) {
      this.fileName = evt.target.files[0].name;
      var fileExtension = evt.target.files[0].name.split('.').pop().toLowerCase(),
        isSuccess = fileTypes.indexOf(fileExtension) > -1;
      this.files = evt.target.files.item(0)


      const target: DataTransfer = <DataTransfer>(evt.target);
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        this.data = <AOA>(XLSX.utils.sheet_to_json(ws));

      };
      reader.readAsBinaryString(target.files[0]);
    }
  }

  geteligibleVin(id) {
    this.spinner.show()
    this.subscription$.add(
      this.authService.getReported(id).subscribe((res: any) => {
        let reports: any = res
        this.downloadFiles(reports)
        this.spinner.hide()
      }))
  }

  downloadFiles(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);

    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "VIN Eligibility.csv");
  }

  vinUplaod(form) {
    let data = []
    this.data.forEach(element => {
      data.push({
        "vin": element.vin ? element.vin : '',
        "country": element.country ? element.country : '',
        "state": element.state ? element.state : ''
      })
    });
    let bulkData = {
      'providerId': form.oem,
      'name': form.description,
      "vinStateCountryList": data ? data : []
    }
    this.spinner.show()
    this.subscription$.add(
      this.authService.bulkvinUpload(bulkData).subscribe((res: any) => {
        this.vinData = res;
        this.vinDataMain = res?.reportId
        this.toastr.success(res?.reportId, "Upload File Status check in VIN Status")
        window.location.reload();
        this.spinner.hide()
      })
    )
    this.getBulkdata();
    this.bulkEnrollmentForm.reset();
    this.files.reset();
  }

  createvinEligibility() {
    this.enrollMentCheckForm = this.fb.group({
      vins: ['', [Validators.required, Validators.pattern("^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17}$")]],
      oems: ['', Validators.required],
    })
  }

  getBulkdata() {
    this.spinner.show()
    this.subscription$.add(
      this.authService.getBulk().subscribe((res: any) => {
        this.bulkData = res;
        this.spinner.hide()
      })
    )
  }

  downloadSamples() {
    var link = document.createElement("a");
    link.href = 'assets/data/ELIGIBILITY-CHECK1.csv';
    link.click();
  }

  vinCheck(vineligibilityModel: any) {
    this.modalService.open(vineligibilityModel, { size: 'lg', centered: true });
  }

  dataModel(mainModel: any) {
    this.modalService.open(mainModel, { size: 'xl', centered: true });
  }
}
